import React from 'react';
import './App.css';

const SLACK_COMMANDS = [
  {
    command: '/capture',
    description: 'Capture a task quickly from Slack. The AI will suggest which Key Result to link it to.',
    examples: [
      '/capture Review Q4 OKRs by Friday',
      '/capture @john Ship the new feature by EOW',
      '/capture Follow up with customer next week'
    ]
  },
  {
    command: '/import-okrs',
    description: 'Import your OKRs into DecisionOS. Opens a modal where you can paste your OKRs in any format.',
    examples: [
      '/import-okrs'
    ]
  },
  {
    command: '/mytasks',
    description: 'View all your open tasks directly in Slack. You can mark tasks as done, snooze them, or delete them.',
    examples: [
      '/mytasks'
    ]
  }
];

function SlackCommandsModal({ isOpen, onClose, onReplayTour }) {
  if (!isOpen) return null;

  return (
    <div className="add-task-modal-overlay" onClick={onClose}>
      <div className="slack-commands-modal-content-zen" onClick={(e) => e.stopPropagation()}>
        <div className="add-task-modal-header">
          <h3>Slack Commands</h3>
          <button className="add-task-modal-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        
        <div className="slack-commands-modal-body-zen">
          {SLACK_COMMANDS.map((cmd, idx) => (
            <div key={idx} className="slack-command-item-zen">
              <div className="slack-command-header">
                <code className="slack-command-name-zen">{cmd.command}</code>
              </div>
              <div className="slack-command-description-zen">{cmd.description}</div>
              {cmd.examples && cmd.examples.length > 0 && (
                <div className="slack-command-examples">
                  {cmd.examples.map((example, exIdx) => (
                    <div key={exIdx} className="slack-command-example-zen">
                      {example}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
          
          <div className="slack-commands-tip">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{flexShrink: 0, marginTop: 2}}>
              <path d="M8 14A6 6 0 108 2a6 6 0 000 12z" stroke="#0F766E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M8 10.667V8M8 5.333h.007" stroke="#0F766E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <div>
              <strong>Quick Tip</strong>
              <p>All commands work in any Slack channel or DM. Tasks captured via <code>/capture</code> will automatically appear in your "My Plan" page.</p>
            </div>
          </div>
          
          {onReplayTour && (
            <div className="slack-commands-footer">
              <button className="replay-tour-btn" onClick={() => { onClose(); onReplayTour(); }}>
                Replay Onboarding Tour
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SlackCommandsModal;

